import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import { thunk } from "redux-thunk";

export default function configureStore() {
  let composeEnhancers = compose;

  if (import.meta.env.DEV) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers;
  }

  return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
}
